module.exports = __webpack_public_path__ + "img/tzgg-icon.33215a87.png";